<template>
    <!-- order form modal -->
    <div id="customConfirmationDialog" v-if="isOrderFormModalOpen">
        <div @click="() => changeOrderModalState(false)" :class="`modal-backdrop ${isOrderFormModalOpen ? '' : 'hidden'}`">
        </div>
        <div id="popupModal" tabindex="-1">
            <!-- modal body -->
            <div class="fixed modal-inner z-[150] sm:w-full w-[90%] max-w-xl max-h-full">
                <div class="relative bg-white rounded-[10px] modal_inner_dialog">
                    <div class="p-[1.1rem_1.5rem] md:p-[1.4rem_1.7rem] ">
                        <h1 class="text-[1rem] text-center font-extrabold">{{ $t('user.enter_order_details') }}</h1>
                        <form v-if="orderForm" @submit.prevent="() => makeOrder()">
                            <div class="flex flex-col space-y-2.5 md:space-y-3 mb-8 mt-3.5">
                                <!-- name & email inputs shows if the user is not logged in -->
                                <div v-if="isNotLoggedIn">
                                    <div class="mt-2">
                                        <label class="text-black inline-block text-[12px] md:text-[13.5px] font-bold mb-1.5" for="name">{{
                                            $t('general.name') }}</label>
                                        <input type="text" id="name" v-model="orderForm.name"
                                            class="w-full h-[41px] bg-[#FFFFFF] caret-primary border-[#DBDBDB] outline-none transition-colors duration-150 placeholder:text-[16px] border text-gray-900 rounded-[7px] focus:border-blue-500 text-sm block pr-3 p-2" />
                                        <!-- error -->
                                        <div v-if="v$ && v$.orderForm && v$.orderForm.name && v$.orderForm.name.$errors">
                                            <p v-for="(error) of v$.orderForm.name.$errors" :key="error.uid"
                                                class="error_message p-4 mb-3 flex flex-column text-sm mt-2.5 text-red-800 rounded-lg bg-red-50"
                                                role="alert">{{ error.$message }}</p>
                                        </div>
                                    </div>
                                    <div class="mt-2">
                                        <label class="text-black inline-block text-[12px] md:text-[13.5px] font-bold mb-1.5" for="email">{{
                                            $t('general.email') }}
                                            <span class="text-gray-500">{{ $t('general.optional')}}</span>
                                            </label>
                                        <input type="email" v-model="orderForm.email" id="email"
                                            class="w-full h-[41px] bg-[#FFFFFF] caret-primary border-[#DBDBDB] outline-none transition-colors duration-150 placeholder:text-[16px] border text-gray-900 rounded-[7px] focus:border-blue-500 text-sm block pr-3 p-2" />
                                        <!-- error -->
                                        <div v-if="v$ && v$.orderForm && v$.orderForm.email && v$.orderForm.email.$errors">
                                            <p v-for="(error) of v$.orderForm.email.$errors" :key="error.uid"
                                                class="error_message p-4 mb-3 flex flex-column text-sm mt-2.5 text-red-800 rounded-lg bg-red-50"
                                                role="alert">{{ error.$message }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div v-else-if="!isGuest" class="mt-2">
                                    <!-- DISCOUNT CODE -->
                                    <!-- nested form for the discount code -->
                                    <form @submit.prevent="onDiscountFormSubmission">
                                        <label class="text-black inline-block text-[12px] md:text-[13.5px] font-bold mb-1.5"
                                            for="discountCode">
                                            {{ $t('user.have_discount_code_question') }}
                                            <span class="text-gray-500">{{ $t('general.optional') }}</span>
                                        </label>
                                        <div>
                                            <div class="flex flex-nowrap items-center h-[41px] gap-2 md:gap-2.5">
                                                <div :class="`${isDiscountInputFocused ? 'border-[2px] border-primary outline-[2px]' : ''} transition-colors duration-150 flex-1 relative border border-[#DBDBDB]`">
                                                    <button v-show="isDiscountCodeApplied" type="button" @click="dismissDiscountCode" class="absolute top-[50%] translate-y-[-50%] rtl:left-3 rtl:right-auto left-auto right-3">
                                                        <img :src="timesIcon" alt class="w-[17.5px] h-[17.5px] 3xl:w-[18px] 3xl:h-[18px]" width="17.5" height="17.5" />
                                                    </button>
                                                    <input type="text" @focus="() => isDiscountInputFocused = true" @blur="() => isDiscountInputFocused = false" :maxlength="6" v-model.trim="discountForm.code" id="discountCode"
                                                        class="w-[90%] h-[41px] bg-[#FFFFFF] caret-primary border-none focus:border-none focus:ring-0 focus:outline-0 transition-colors duration-150 placeholder:text-[16px] border text-gray-900 rounded-[2px] focus:border-blue-500 text-sm block pr-3 p-2" />
                                                </div>
                                                <button :disabled="disableTheDiscountCodeButton" :class="`${disableTheDiscountCodeButton ? 'disabled' : ''} bg-primary transition-colors duration-150 text-center px-2.5 rounded-[7px] h-full`">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="19"
                                                        viewBox="0 0 24 24">
                                                        <g fill="none" fill-rule="evenodd">
                                                            <path
                                                                d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
                                                            <path fill="white"
                                                                d="M21.546 5.111a1.5 1.5 0 0 1 0 2.121L10.303 18.475a1.6 1.6 0 0 1-2.263 0L2.454 12.89a1.5 1.5 0 1 1 2.121-2.121l4.596 4.596L19.424 5.111a1.5 1.5 0 0 1 2.122 0" />
                                                        </g>
                                                    </svg>
                                                </button>
                                            </div>
                                            <!-- code percentage -->
                                            <div v-show="isDiscountCodeApplied" class="mt-2">
                                                <span class="flex ltr:flex-row-reverse ltr:float-left justify-start gap-1 text-[#EC2B2B] text-[12.5px] md:text-[13px]">
                                                    <span>{{ $t('user.discount') }}</span>
                                                    <strong>%{{ couponDiscountPercentage }}</strong>
                                                </span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div class="mt-2">
                                    <label class="text-black inline-block text-[12px] md:text-[13.5px] font-bold mb-1.5" for="phone">{{
                                        $t('general.phone') }}</label>
                                    <input type="text" v-model="orderForm.phone" id="phone" maxlength="11"
                                        @input="(e) => orderForm.phone = (e.target.value).replace(/\D/g, '')"
                                        class="w-full h-[41px] bg-[#FFFFFF] caret-primary border-[#DBDBDB] outline-none transition-colors duration-150 placeholder:text-[16px] border text-gray-900 rounded-[7px] focus:border-blue-500 text-sm block pr-3 p-2" />
                                    <!-- error -->
                                    <div v-if="v$ && v$.orderForm && v$.orderForm.phone && v$.orderForm.phone.$errors">
                                        <p v-for="(error) of v$.orderForm.phone.$errors" :key="error.uid"
                                            class="error_message p-4 mb-3 flex flex-column text-sm mt-2.5 text-red-800 rounded-lg bg-red-50"
                                            role="alert">{{ error.$message }}</p>
                                    </div>
                                </div>
                                <div class="mt-2">
                                    <label class="text-black inline-block text-[12px] md:text-[13.5px] font-bold mb-1.5" for="quantity">{{
                                        $t('general.quantity') }}</label>
                                    <input type="number" v-model="orderForm.quantity" :min="1"
                                        :placeholder="`${$t('general.default_value')} (1)`" id="quantity"
                                        class="w-full h-[41px] bg-[#FFFFFF] caret-primary border-[#DBDBDB] outline-none transition-colors duration-150 placeholder:text-[16px] border text-gray-900 rounded-[7px] focus:border-blue-500 text-sm block pr-3 p-2" />
                                    <!-- error -->
                                    <div
                                        v-if="v$ && v$.orderForm && v$.orderForm.quantity && v$.orderForm.quantity.$errors">
                                        <p v-for="(error) of v$.orderForm.quantity.$errors" :key="error.uid"
                                            class="error_message p-4 mb-3 flex flex-column text-sm mt-2.5 text-red-800 rounded-lg bg-red-50"
                                            role="alert">{{ error.$message }}</p>
                                    </div>
                                </div>

                                <div class="mt-2">
                                    <label class="text-black inline-block text-[12px] md:text-[13.5px] font-bold mb-1.5" for="address">{{
                                        $t('general.address') }}</label>
                                    <textarea v-model="orderForm.address" name="textarea" id="address"
                                        :class="`resize-none w-full h-20  bg-[#FFFFFF] caret-primary border-[#DBDBDB] outline-none transition-colors duration-150 placeholder:text-[16px] border text-gray-900 rounded-[7px] focus:border-blue-500 text-sm block pr-3 p-2.5`"></textarea>
                                    <!-- error -->
                                    <div v-if="v$ && v$.orderForm && v$.orderForm.address && v$.orderForm.address.$errors">
                                        <p v-for="(error) of v$.orderForm.address.$errors" :key="error.uid"
                                            class="error_message p-4 mb-3 flex flex-column text-sm mt-2.5 text-red-800 rounded-lg bg-red-50"
                                            role="alert">{{ error.$message }}</p>

                                    </div>

                                </div>
                                <!-- price after discount (if applied) -->
                                <div v-if="isDiscountCodeApplied && orderForm && orderForm.quantity" class="flex flex-wrap justify-between items-center p-2 lg:p-2.5 xl:py-2.5 xl:px-3 mt-1.5 mb-6 bg-[#D4E3FC] rounded-[2px]">
                                    <span class="text-[14px] md:text-[14.5px] 3xl:text-[15px]">{{ $t('general.price_after_discount') }}</span>
                                    <div class="min-w-[80px] lg:min-w-[95px]">
                                        <!-- actual price -->
                                        <div v-if="+productBasicPrice > 0" class="flex flex-col gap-1.5">
                                            <div>
                                                <div v-if="priceAfterDiscount"
                                                    class="flex flex-wrap gap-1 md:gap-1.5 items-center text-center">
                                                    <strong class="text-[15px] md:text-[15.5px] 3xl:text-[16px]">
                                                        {{ arabizeNumbers(Math.round(Number(priceAfterDiscount)).toLocaleString()) }}
                                                    </strong>
                                                    <span >{{ $t('general.egyptian_pound') }}</span>
                                                </div>
                                                <div v-else-if="+priceAfterDiscount <= 0">
                                                    <small class="font-bold">{{ $t('general.free') }}</small>
                                                </div>
                                                <span v-else> — </span>
                                            </div>
                                        </div>
                                        <!-- free -->
                                        <div v-if="+productBasicPrice == 0">
                                            <small class="font-bold">{{ $t('general.free') }}</small>
                                        </div>
                                        <!-- price will be determind later -->
                                        <div v-if="+productBasicPrice < 0">
                                            <small class="font-bold">{{ $t('general.price_will_be_specificed_later') }}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- submit main form's buttons -->
                            <div class="flex flex-wrap justify-start items-center gap-2 md:gap-2.5">
                                <button :disabled="isLoading" type="submit"
                                    :class="`${isLoading ? 'disabled' : ''} text-white bg-[#0963FF] sm:w-[30%] lg:w-[33%] w-full py-[0.65rem] sm:py-2.5 sm:text-sm text-xs hover:bg-[#0963ffd6] font-bold border border-gray-200 focus:ring-4 focus:outline-none rounded-[7px]`">{{
                                        $t(`general.confirm`) }}</button>
                                <span :disabled="isLoading" @click="() => changeOrderModalState(false)"
                                    :class="`${isLoading ? 'disabled' : ''} cursor-pointer text-center text-black  bg-[#d1d1d1] sm:w-[30%] lg:w-[33%] w-full py-[0.65rem] sm:py-2.5 sm:text-sm text-xs hover:bg-[#d1d1d1cf] focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-[7px] border border-gray-200 font-bold  hover:text-gray-900 focus:z-10`">{{
                                        $t(`general.cancel`) }}</span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import timesIcon from "@/assets/icons/times_red.svg";
import { APIREQUESTS, MAINROLES, constructQueryString, getPriceAfterDiscount } from "@/helpers";

export default {
    data() {
        return {
            timesIcon,
            v$: useVuelidate(),
            receivedCouponInfo: {},
            isDiscountInputFocused: false,
            isGettingDiscountPercentage: false,
            discountForm: {
                code: "",
            },
            orderForm: {
                address: "",
                phone: "",
                quantity: 1,
            },
        }
    },
    props: {
        isOrderFormModalOpen: {
            type: Boolean,
            default: false,
            required: true
        },
        isNotLoggedIn: {
            type: Boolean,
            default: false,
            required: true
        },
        isGuest: {
            type: Boolean,
            default: false,
            required: true
        },
        isLoading: {
            type: Boolean,
            default: false,
            required: true
        },
        changeOrderModalState: {
            type: Function,
            required: true
        },
        handleCreateOrder: {
            type: Function,
            required: true
        },
        productId: {
            type: [String, Number],
            default: "",
            required: true
        },
        productUpdatedPrice: {
            type: [String, Number],
            default: "",
            required: true
        },
        productBasicPrice: {
            type: [String, Number],
            default: "",
            required: true
        },
    },
    computed:{
        disableTheDiscountCodeButton(){
            return this.discountForm.code == "" || this.isGettingDiscountPercentage;
        },
        isDiscountCodeApplied(){
            return this.receivedCouponInfo?.discount || this.receivedCouponInfo?.code
        },
        couponDiscountPercentage(){
            return Math.round(+this.receivedCouponInfo?.discount);
        },
        priceAfterDiscount(){
            const discount = +this.receivedCouponInfo?.discount || 0;
            const basicPrice = +this.productBasicPrice;
            const updatedPrice = +this.productUpdatedPrice;
            const discountedPrice = +getPriceAfterDiscount({mainPrice: updatedPrice, discount});
            return basicPrice > 0  ? (discountedPrice * +this.orderForm.quantity) : basicPrice;
        }
    },
    validations() {
        return {
            discountForm: {
                code: {
                    ...this.VALIDATIONS.requiredInput,
                }
            },
            orderForm: {
                ...(this.isNotLoggedIn && {
                    name: {
                        ...this.VALIDATIONS.name,
                    },
                    email: { },
                }),
                phone: {
                    ...this.VALIDATIONS.phone,
                },
                address: {
                    ...this.VALIDATIONS.orderAddress,
                },
                quantity: {
                    // required: helpers.withMessage(
                    //   () => this.$t("general.input_required"),
                    //   required
                    // ),
                    isPositive: helpers.withMessage(
                        () => this.$t("general.must_be_positive_number"),
                        val => typeof val == '' ? true : +val >= 0
                    )
                },

            }
        }
    },
    methods: {       
        dismissDiscountCode(){
            this.receivedCouponInfo = {};
        },
        resetOrderForm() {
            this.v$?.orderForm?.$reset();
            this.orderForm.phone = "";
            this.orderForm.address = "";
            this.orderForm.quantity = 1;
            this.discountForm.code = "";
            if (this.isNotLoggedIn) {
                this.orderForm.name = "";
                this.orderForm.email = "";
            }
            this.dismissDiscountCode();
        },
        makeOrder() {
            this.v$?.orderForm?.$touch();
            if (!this.v$?.orderForm?.$invalid) {
                const { orderForm, receivedCouponInfo } = this;
                const formData = {
                    ...orderForm,
                    // include the coupon ID if it's applied
                    ...(receivedCouponInfo?.id && {
                        product_coupon_id: receivedCouponInfo.id
                    })
                }

                this.handleCreateOrder(formData).then(() => {
                    fbq('track', 'Purchase');
                    this.resetOrderForm();
                })
            }
        },

        getDiscountPercentage({ product_id, code }){
                if( !product_id || !code ){
                    this.notify({ type: "error", msg: this.$t('general.failed') })
                    return;
                }
                const queryString = constructQueryString([{key: 'code', value: code}, {key: 'product_id', value: product_id}]);
                this.isGettingDiscountPercentage = true;
                this.makeRequest({
                    owner: MAINROLES.user,
                    url: `${APIREQUESTS.user.applyProductCoupon.url}${queryString}`,
                    method: APIREQUESTS.user.applyProductCoupon.method,
                    formData: {
                        product_id,
                        code
                    }
                })
                    .then((res) => {
                        //check response
                        if (!res.status) {
                            //failed
                            this.notify({ type: "error", msg: res?.message || this.$t('general.failed') })
                        } else {
                            //succeeded
                            const receivedCouponData = res?.data;
                            if(receivedCouponData){
                                // forward the resulted information to the next request
                                const mainPrice = this.productUpdatedPrice || 0;
                                this.receivedCouponInfo = {
                                    ...receivedCouponData,
                                    priceAfterDiscount: getPriceAfterDiscount({mainPrice, discount: receivedCouponData.discount})
                                };
                            }else{
                                this.notify({ type: "error", msg: this.$t('general.failed') })
                            }
                        }
                    })
                    .catch((err) => {
                        this.notify({ type: "error", msg: err?.data?.message || this.$t('general.failed') })
                    }).finally(() =>{
                        this.isGettingDiscountPercentage = false;
                    })
        },
        onDiscountFormSubmission(){
            this.v$?.discountForm?.$touch();
            if(!this.v$?.discountForm?.$invalid || this.disableTheDiscountCodeButton){
                const product_id = this.productId;
                const code = this.discountForm?.code;

                this.getDiscountPercentage({product_id, code});
            }
        }
    },
    watch: {
        isOrderFormModalOpen(val) {
            if (typeof val == 'boolean' && !val) {
                this.resetOrderForm();
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            if (this.isNotLoggedIn) {
                // if Guest, add the extra data (name, and email) to the orderForm object
                this.orderForm = {
                    ...this.orderForm,
                    name: "",
                    email: "",
                }
            }
        })
    }
}
</script>

<style></style>